'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.default = prependClass;

var _ramda = require('ramda');

var _functor = require('./functor');

var _functor2 = _interopRequireDefault(_functor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prependClass(className) {
  return (0, _ramda.mapObjIndexed)(function (value, key) {
    if (key === 'class') {
      var _ret = function () {
        var fn = (0, _functor2.default)(value);

        return {
          v: function v(d, i) {
            var classNames = fn(d, i);
            if (classNames !== className) {
              return (0, _ramda.join)(' ', [className, classNames]);
            }
            return classNames;
          }
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }

    return value;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3tooltip/lib/utils/prependClass.js
// module id = 486
// module chunks = 0